import {Component} from 'panel';

import template from './index.jade';
import css from './index.styl?inline';

export class ViewAnnotationsButton extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'num-annotations': `number`,
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}
customElements.define(`view-annotations-button`, ViewAnnotationsButton);
